var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTabs)?_c('DxTabs',{attrs:{"data-source":_vm.tabs,"selected-index":_vm.selectedIndex,"on-item-click":_vm.itemClick,"focusStateEnabled":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }